import { render, staticRenderFns } from "./cms-block-divider.vue?vue&type=template&id=8867dd44&scoped=true"
import script from "./cms-block-divider.vue?vue&type=script&lang=js"
export * from "./cms-block-divider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8867dd44",
  null
  
)

export default component.exports